import ViewSettings from "components/Settings/ViewSettings";

export const SettingsPage = () =><ViewSettings></ViewSettings>;
